import { render, staticRenderFns } from "./config_device.vue?vue&type=template&id=742b6adf&scoped=true&"
import script from "./config_device.vue?vue&type=script&lang=js&"
export * from "./config_device.vue?vue&type=script&lang=js&"
import style0 from "./config_device.vue?vue&type=style&index=0&id=742b6adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b6adf",
  null
  
)

export default component.exports